import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import CommonSelect from 'components/controls/CommonSelect';
import { useOnUpdate } from 'js/customHooks'

export default function ParametersSelect() {
  const parameters = useSelector((state) => state.parameters);
  const parameter = useSelector((state) => state.parameter);
  const dispatch = useDispatch();


  function getContent(){
    return {
      title:"Parameter",
      opts: parameters ? Object.keys(parameters).map((p) => ([parameters[p].id, parameters[p].name])) : [],
      buttons: [], 
      current: parameter ? parameter : ""
    }
  }

  function getFuncs(){
    return {
      clickItem: clickItem
    }
  }

  const clickItem = (ev) => {
    dispatch({ type: 'SET_PARAMETER', payload: ev.target.textContent});
  }

  useOnUpdate(() => {
    //dispatch({ type: 'SET_DATASETS', payload: parameters[parameter]["datasets"]});
    //dispatch({ type: 'SET_DATASET', payload: parameters[parameter]["datasets"][0].name});
  }, [parameter] )

  useEffect(() => { 
    console.log('render ParameterSelect')
  });

  return (
    <CommonSelect funcs={getFuncs()} content={getContent()} title="The ocean variable to validate"/>
  )
}